import { render, staticRenderFns } from "./BridalItemGroupMenu.vue?vue&type=template&id=44530554"
import script from "./BridalItemGroupMenu.vue?vue&type=script&lang=js"
export * from "./BridalItemGroupMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports